/**
 * Copyright (C) 2017 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiBase from '@here/lui-base'
import scopedCss from 'lui-notification.scss'
import template from 'lui-notification.html'

export default class LuiNotification extends LuiBase {
  static get is() {
    return 'lui-notification'
  }

  static get cssClassToggles() {
    return []
  }

  static get css() {
    return scopedCss
  }

  static get template() {
    return template
  }

  init() {
    super.init()
    this._hideTitleIfEmpty()
  }

  onConnected() {
    this._close = this._close || (() => this.close())
    this.clearButton.addEventListener('click', this._close)

    const impact = this.getAttribute('impact')
    if (impact) {
      this.classList.add(`lui-${impact}`)
      this.seedElement.classList.add(`lui-${impact}`)
    }
  }

  onDisconnected() {
    this.clearButton.removeEventListener('click', this._close)
  }

  openChanged(oldValue, newValue) {
    if (newValue === '') {
      let timeout = this.getAttribute('timeout')
      if (timeout !== null) {
        timeout = timeout === '' ? 5000 : Number.parseInt(timeout)
        setTimeout(() => {
          this.close()
        }, timeout)
      }
    }
  }

  showModal() {
    console.warn('LuiNotification.showModal is deprecated use LuiNotification.show instead')
    this.show()
  }

  show() {
    // this.delay is needed two times as the first opening of the
    // Overlay sometimes lacks the animation otherwise.
    this.delay(() => {
      this._hideTitleIfEmpty()
      this.style.display = 'block'
      this.delay(() => {
        this.setAttribute('open', '')
      })
    })
  }

  close() {
    if (this.getAttribute('variant') === 'lightbox') {
      this.addEventListener('transitionend', this.hide)
    } else {
      this.addEventListener('transitionend', this.remove)
      const {
        transitionDuration,
        paddingTop,
        paddingBottom,
      } = window.getComputedStyle(this.seedElement)
      const {lineHeight} = window.getComputedStyle(this)

      const speedFactor = (this.scrollHeight - parseInt(paddingTop) - parseInt(paddingBottom)) / parseInt(lineHeight)
      this.style.transitionDuration = `calc(${speedFactor} * ${transitionDuration})`
      this.style.marginTop = -this.scrollHeight + 'px'
    }

    this.removeAttribute('open')
  }

  remove() {
    this.removeEventListener('transitionend', this.remove)
    this.parentNode.removeChild(this)
  }

  hide() {
    this.removeEventListener('transitionend', this.hide)
    this.style.display = 'none'
  }

  _hideTitleIfEmpty() {
    const isTitleEmpty = !this.querySelector('[slot="title"]')
    this.shadowRoot.querySelector('.lui-notification__content-title').style.display = isTitleEmpty ? 'none' : 'block'
  }

  get clearButton() {
    this._clearButton = this._clearButton || this.shadowRoot.querySelector('lui-clear')
    return this._clearButton
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-notification/lui-notification.js
// module id = 262
// module chunks = 0 1 5